import request from "@/utils/request";
export function getCarList(data: any) {
  return request({
    url: "/project/projectVisitCarLog/page",
    method: "get",
    params: data,
  });
}
